module.exports = {
  BEFORE_EACH_ITERATION:  0,
  BEFORE_INSTANCE_UPDATE: 1,
  ON_INSTANCE_CREATE:  2,
  AFTER_DOM_CREATE:       3,
}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/constants/hookTypes.js